'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _components = require('../../components');



var _packagesConfigs = require('./packagesConfigs');

var _RealtorPackagesContainer = require('./RealtorPackagesContainer.scss');var styles = _interopRequireWildcard(_RealtorPackagesContainer);
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _PaymentContainer = require('../PaymentContainer/PaymentContainer');var _PaymentContainer2 = _interopRequireDefault(_PaymentContainer);
var _payments = require('../../redux/modules/payments');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var PACKAGE_VIEWS = {
  CALCULATOR: 'calculator',
  LIST: 'list' };


var mobilePackageViews = [PACKAGE_VIEWS.CALCULATOR, PACKAGE_VIEWS.LIST];

var getMobilePackageViews = function getMobilePackageViews(translate) {return mobilePackageViews.map(function (view) {return {
      value: view,
      label: translate(view) };});};var


RealtorPackagesContainer = function (_Component) {_inherits(RealtorPackagesContainer, _Component);
  function RealtorPackagesContainer(props) {_classCallCheck(this, RealtorPackagesContainer);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.





    handleChoosePackage = function (packageInstance) {
      _this.props.changeSelectedPayment(packageInstance.legacyPackageDescription).
      then(function () {return _this.props.openDetailsToInvoiceForm(packageInstance);});
    };_this.

    changeView = function (view) {return _this.setState({ currentView: view });};_this.

    changePropertiesCount = function (value) {return _this.setState({ calculatorSelectedPropertiesCount: value });};_this.

    changePackagesPeriod = function (period) {return _packagesConfigs.realtorPackages.forEach(function (instance) {return instance.changePeriod(period);});};_this.

    findPackageByProperties = function (count) {return _packagesConfigs.realtorPackages.
      find(function (pack) {return pack[_packagesConfigs.PROMOTIONS.PROPERTIES] === Number(count);}) ||
      _packagesConfigs.realtorPackages[0];};_this.

    packageInstance = function () {
      var packageInstance = _this.findPackageByProperties(_this.state.calculatorSelectedPropertiesCount);
      packageInstance.features.page = _this.props.isPage;
      return packageInstance;
    };_this.

    renderPackage = function (packageInstance) {
      packageInstance._period = _this.props.isPage;
      return (
        _react2.default.createElement(_components.RealtorPackage, {
          key: packageInstance.id,
          isRtl: _this.props.isRtl,
          packageInstance: packageInstance,
          discountCoupon: _this.props.discountCoupon,
          translate: _this.props.translate,
          locale: _this.props.locale,
          handleChoosePackage: _this.handleChoosePackage }));


    };_this.

    renderSwitcher = function () {return (
        _react2.default.createElement(_components.HomePagePropertiesChips, {
          name: 'mobile-realtors-packages-views',
          values: getMobilePackageViews(_this.props.translate),
          selectedValue: _this.state.currentView,
          onChange: _this.changeView,
          className: 'switcher-transparent' }));};_this.state = { currentView: PACKAGE_VIEWS.CALCULATOR };return _this;}RealtorPackagesContainer.prototype.



  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.packages },
        this.props.windowWidth <= 1000 && this.state.currentView === PACKAGE_VIEWS.CALCULATOR ?

        _react2.default.createElement(_components.RealtorPackage, {
          isRtl: this.props.isRtl,
          packageInstance: this.findPackageByProperties(this.props.calculatorSelectedPropertiesCount),
          translate: this.props.translate,
          locale: this.props.locale,
          changePropertiesCount: this.changePropertiesCount,
          changePackagesPeriod: this.changePackagesPeriod,
          discountCoupon: this.props.discountCoupon,
          isCalculator: true,
          handleChoosePackage: this.handleChoosePackage }) :


        _packagesConfigs.realtorPackages.map(this.renderPackage)));


  };return RealtorPackagesContainer;}(_react.Component);


RealtorPackagesContainer.propTypes = {
  openDetailsToInvoiceForm: _propTypes2.default.func,
  changeSelectedPayment: _propTypes2.default.func,
  handleChoosePackage: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  packagesTranslate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  windowWidth: _propTypes2.default.number,
  isAgent: _propTypes2.default.bool,
  discountCoupon: _propTypes2.default.string,
  isPage: _propTypes2.default.object,
  calculatorSelectedPropertiesCount: _propTypes2.default.string };


var mapStateToProps = function mapStateToProps(state) {return {
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    translate: (0, _reduxPagan.getLang)(state.lang, 'RealtorLanding'),
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    packagesTranslate: (0, _reduxPagan.getLang)(state.lang, 'PublishProperty'),
    isAgent: (0, _get2.default)(state, 'userAuthentication.data.is_agent'),
    locale: state.lang.locale,
    windowWidth: state.windowDimentions.width,
    discountCoupon: (0, _get2.default)(state, 'discountCoupon.data.type') };};exports.default =


(0, _PaymentContainer2.default)(
(0, _reactRedux.connect)(mapStateToProps, { changeSelectedPayment: _payments.changeSelectedPayment })(
RealtorPackagesContainer));module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorPackagesContainer/RealtorPackagesContainer.js
// module id = 2985
// module chunks = 0